var map = {
	"./acmilan-logo-icon.png": "b94f",
	"./aek-athens-logo-icon.png": "52af",
	"./afc-bournemouth-logo-icon.png": "1c49",
	"./afghanistan-logo-icon.png": "2a09",
	"./ajaccio-logo-icon.png": "d806",
	"./ajax-amsterdam-logo-icon.png": "d101",
	"./ajax-logo-icon.png": "aed4",
	"./alaves-logo-icon.png": "ee0b",
	"./albania-logo-icon.png": "0fd7",
	"./almeria-logo-icon.png": "414b",
	"./amazulu-logo-icon.png": "e01a",
	"./angers-sco-logo-icon.png": "eb63",
	"./antwerp-logo-icon.png": "1423",
	"./apollon-logo-icon.png": "af0d",
	"./argentina-logo-icon.png": "9924",
	"./aris-limassol-logo-icon.png": "0bf0",
	"./arsenal-logo-icon.png": "ee5f",
	"./aston-villa-logo-icon.png": "83e7",
	"./atalanta-logo-icon.png": "90d7",
	"./athletic-bilbao-logo-icon.png": "28e4",
	"./athletic-club-logo-icon.png": "3e79",
	"./atlanta-logo-icon.png": "0e3f",
	"./atletico-madrid-logo-icon.png": "c141",
	"./australia-logo-icon.png": "6483",
	"./austria-logo-icon.png": "a05b",
	"./auxerre-logo-icon.png": "093d",
	"./bangladesh-logo-icon.png": "6490",
	"./barcelona-logo-icon.png": "2313",
	"./baroka-logo-icon.png": "3fd6",
	"./bayer-leverkusen-logo-icon.png": "2e87",
	"./bayern-munchen-logo-icon.png": "545a",
	"./belgium-logo-icon.png": "9a68",
	"./benetton-rugby-logo-icon.png": "6edf",
	"./benfica-logo-icon.png": "3bae",
	"./blue-bulls-logo-icon.png": "4feb",
	"./bodo-glimt-logo-icon.png": "a1bb",
	"./bologna-logo-icon.png": "b2cc",
	"./bordeaux-logo-icon.png": "f5d8",
	"./borussia-dortmund-logo-icon.png": "fc6f",
	"./brazil-logo-icon.png": "757c",
	"./brentford-logo-icon.png": "fcb1",
	"./brest-logo-icon.png": "5517",
	"./brighton-&-hove-albion-logo-icon.png": "659c",
	"./bulls-logo-icon.png": "bbbf",
	"./burnley-logo-icon.png": "c356",
	"./cadiz-logo-icon.png": "0a5e",
	"./cameroon-logo-icon.png": "b376",
	"./canada-logo-icon.png": "6471",
	"./cape-town-city-logo-icon.png": "e41c",
	"./cape-town-spurs-logo-icon.png": "7b7a",
	"./cardiff-rugby-logo-icon.png": "9173",
	"./celta-de-vigo-logo-icon.png": "f4c0",
	"./celta-vigo-logo-icon.png": "6743",
	"./celtic-fc-logo-icon.png": "2405",
	"./celtic-logo-icon.png": "5a8c",
	"./chelsea-logo-icon.png": "e152",
	"./china-pr-logo-icon.png": "7229",
	"./chippa-united-logo-icon.png": "3e09",
	"./clermont-logo-icon.png": "0667",
	"./club-brugge-kv-logo-icon.png": "9e04",
	"./club-brugge-logo-icon.png": "4236",
	"./colombia-logo-icon.png": "392b",
	"./connacht-rugby-logo-icon.png": "9988",
	"./costa-rica-logo-icon.png": "681f",
	"./cremonese-logo-icon.png": "b165",
	"./croatia-logo-icon.png": "a755",
	"./crvena-zvezda-logo-icon.png": "999e",
	"./crystal-palace-logo-icon.png": "6bf0",
	"./czech-republic-logo-icon.png": "ea42",
	"./denmark-logo-icon.png": "758f",
	"./deportivo-alaves-logo-icon.png": "35c9",
	"./dinamo-zagreb-logo-icon.png": "8d8f",
	"./dragons-rfc-logo-icon.png": "84ed",
	"./durban-super-giants-logo-icon.png": "9259",
	"./dynamo-kyiv-logo-icon.png": "8708",
	"./ecuador-logo-icon.png": "f57a",
	"./edinburgh-rugby-logo-icon.png": "a02c",
	"./eintracht-frankfurt-logo-icon.png": "6b23",
	"./elche-logo-icon.png": "da3f",
	"./empoli-logo-icon.png": "d817",
	"./england-logo-icon.png": "a95a",
	"./espanyol-logo-icon.png": "6dd8",
	"./everton-logo-icon.png": "5cea",
	"./ferencvaros-logo-icon.png": "c96b",
	"./feyenoord-logo-icon.png": "5410",
	"./fiorentina-logo-icon.png": "5be8",
	"./france-logo-icon.png": "ad5d",
	"./free-state-cheetahs-logo-icon.png": "521f",
	"./fulham-logo-icon.png": "1135",
	"./galatasaray-logo-icon.png": "3b83",
	"./georgia-logo-icon.png": "c79a",
	"./germany-logo-icon.png": "b467",
	"./getafe-logo-icon.png": "20ec",
	"./ghana-logo-icon.png": "9e4e",
	"./girona-logo-icon.png": "9b23",
	"./glasgow-warriors-logo-icon.png": "71e2",
	"./golden-arrows-logo-icon.png": "9df9",
	"./granada-logo-icon.png": "1026",
	"./griffons-logo-icon.png": "27cf",
	"./griquas-logo-icon.png": "757d",
	"./haiti-logo-icon.png": "e887",
	"./hellas-verona-logo-icon.png": "250a",
	"./hungary-logo-icon.png": "78fa",
	"./india-logo-icon.png": "3d59",
	"./inter-milan-logo-icon.png": "f6da",
	"./internazionale-logo-icon.png": "b120",
	"./ipswich-town-logo-icon.png": "e729",
	"./iran-logo-icon.png": "9802",
	"./ireland-logo-icon.png": "e119",
	"./italy-logo-icon.png": "acdc",
	"./jamaica-logo-icon.png": "aa9b",
	"./japan-logo-icon.png": "12c7",
	"./joburg-super-kings-logo-icon.png": "a561",
	"./juventus-logo-icon.png": "fe4a",
	"./kaizer-chiefs-logo-icon.png": "e074",
	"./ki-logo-icon.png": "28ca",
	"./kobenhavn-logo-icon.png": "7e42",
	"./korea-republic-logo-icon.png": "67ff",
	"./lazio-logo-icon.png": "5036",
	"./lecce-logo-icon.png": "c091",
	"./leeds-united-logo-icon.png": "fe36",
	"./leicester-city-logo-icon.png": "779b",
	"./leinster-rugby-logo-icon.png": "2fd7",
	"./lens-logo-icon.png": "a412",
	"./levante-logo-icon.png": "916c",
	"./lille-logo-icon.png": "ea73",
	"./lions-logo-icon.png": "04ee",
	"./liverpool-logo-icon.png": "e416",
	"./lorient-logo-icon.png": "75c7",
	"./ludogorets-logo-icon.png": "168e",
	"./luton-town-logo-icon.png": "cccc",
	"./maccabi-haifa-logo-icon.png": "e849",
	"./mallorca-logo-icon.png": "5585",
	"./mamelodi-sundowns-logo-icon.png": "c9ea",
	"./manchester-city-logo-icon.png": "f34b",
	"./manchester-united-logo-icon.png": "cb69",
	"./maritzburg-united-logo-icon.png": "b0d6",
	"./marseilles-fc-logo-icon.png": "a738",
	"./marumo-gallants-logo-icon.png": "5594",
	"./metz-logo-icon.png": "c842",
	"./mexico-logo-icon.png": "4aed",
	"./mi-cape-town-logo-icon.png": "2eb2",
	"./midtylland-logo-icon.png": "1ebf",
	"./milan-logo-icon.png": "cd25",
	"./molde-logo-icon.png": "c35c",
	"./monaco-logo-icon.png": "f011",
	"./montpellier-logo-icon.png": "0e69",
	"./monza-logo-icon.png": "bd64",
	"./morocco-logo-icon.png": "9840",
	"./munster-rugby-logo-icon.png": "3dbc",
	"./nambia-logo-icon.png": "2fed",
	"./nantes-logo-icon.png": "ae89",
	"./napoli-logo-icon.png": "1d67",
	"./netherlands-logo-icon.png": "a727",
	"./new-zealand-logo-icon.png": "762f",
	"./newcastle-united-logo-icon.png": "04dc",
	"./nice-logo-icon.png": "fe0b",
	"./nigeria-logo-icon.png": "4e8b",
	"./norway-logo-icon.png": "2559",
	"./norwich-logo-icon.png": "2f6d",
	"./nottingham-forest-logo-icon.png": "cfb5",
	"./olimpija-logo-icon.png": "1b20",
	"./olympique-lyonnais-logo-icon.png": "4b0d",
	"./olympique-marseille-logo-icon.png": "5733",
	"./orlando-pirates-logo-icon.png": "e422",
	"./osasuna-logo-icon.png": "4a33",
	"./ospreys-logo-icon.png": "22c5",
	"./paarl-royals-logo-icon.png": "dbd3",
	"./pakistan-logo-icon.png": "2ccc",
	"./panama-logo-icon.png": "7132",
	"./panathinaikos-logo-icon.png": "2cd9",
	"./philippines-logo-icon.png": "8107",
	"./poland-logo-icon.png": "e2ad",
	"./polokwane-city-logo-icon.png": "29b7",
	"./porto-logo-icon.png": "329b",
	"./portugal-logo-icon.png": "eced",
	"./pretoria-capitals-logo-icon.png": "f336",
	"./psg-logo-icon.png": "62da",
	"./psv-logo-icon.png": "027e",
	"./pumas-logo-icon.png": "8fc5",
	"./pyunik-logo-icon.png": "26dd",
	"./qarabag-fk-logo-icon.png": "f543",
	"./qarabag-logo-icon.png": "600d",
	"./qatar-logo-icon.png": "d757",
	"./rakow-czestochowa-logo-icon.png": "97c3",
	"./rangers-logo-icon.png": "a51e",
	"./rayo-vallecano-logo-icon.png": "4bb6",
	"./rb-leipzig-logo-icon.png": "0367",
	"./real-betis-logo-icon.png": "e924",
	"./real-madrid-logo-icon.png": "2dba",
	"./real-sociedad-logo-icon.png": "6026",
	"./real-valladolid-logo-icon.png": "539a",
	"./reims-logo-icon.png": "22e7",
	"./rennes-logo-icon.png": "fe04",
	"./republic-of-ireland-logo-icon.png": "36b4",
	"./richards-bay-logo-icon.png": "57dd",
	"./roma-logo-icon.png": "57e5",
	"./romania-logo-icon.png": "0c48",
	"./royal-am-logo-icon.png": "2cae",
	"./saint-etienne-logo-icon.png": "3bf2",
	"./salernitana-logo-icon.png": "4042",
	"./salzburg-logo-icon.png": "0d3f",
	"./sampdoria-logo-icon.png": "6a42",
	"./sassuolo-logo-icon.png": "c8a2",
	"./saudi-arabia-logo-icon.png": "4a52",
	"./scarlets-logo-icon.png": "a27b",
	"./scotland-logo-icon.png": "d887",
	"./sekhukhune-united-logo-icon.png": "0aba",
	"./senegal-logo-icon.png": "06b8",
	"./serbia-logo-icon.png": "4d04",
	"./servette-logo-icon.png": "3be3",
	"./sevilla-logo-icon.png": "b603",
	"./shakhtar-donetsk-logo-icon.png": "19fe",
	"./sharks-logo-icon.png": "b740",
	"./sharks-xv-logo-icon.png": "049e",
	"./sheffield-united-logo-icon.png": "bb9d",
	"./sheriff-logo-icon.png": "5df2",
	"./sigma-lions-logo-icon.png": "af71",
	"./slovakia-logo-icon.png": "a58a",
	"./slovan-bratislava-logo-icon.png": "3648",
	"./slovenia-logo-icon.png": "e9be",
	"./south-africa-logo-icon.png": "154d",
	"./southampton-logo-icon.png": "08b3",
	"./spain-logo-icon.png": "2c50",
	"./sparta-praha-logo-icon.png": "989c",
	"./spezia-logo-icon.png": "17d8",
	"./sporting-braga-logo-icon.png": "0294",
	"./sporting-cp-logo-icon.png": "188c",
	"./sri-lanka-logo-icon.png": "8460",
	"./stade-brestois-logo-icon.png": "314f",
	"./stellenbosch-logo-icon.png": "244a",
	"./stormers-logo-icon.png": "ca26",
	"./strasbourg-logo-icon.png": "a9a1",
	"./sturm-graz-logo-icon.png": "a4ed",
	"./sunrisers-eastern-cape-logo-icon.png": "3142",
	"./supersport-united-logo-icon.png": "492f",
	"./swallows-logo-icon.png": "22f5",
	"./sweden-logo-icon.png": "baaa",
	"./switzerland-logo-icon.png": "6da0",
	"./torino-logo-icon.png": "aa6f",
	"./tottenham-hotspur-logo-icon.png": "7cf1",
	"./toulouse-logo-icon.png": "ec84",
	"./trabzonspor-logo-icon.png": "a8f1",
	"./troyes-logo-icon.png": "8e54",
	"./ts-galaxy-logo-icon.png": "9d93",
	"./tsc-logo-icon.png": "4fcc",
	"./ttm-logo-icon.png": "4705",
	"./tunisia-logo-icon.png": "03d2",
	"./turkey-logo-icon.png": "d66b",
	"./uae-logo-icon.png": "1149",
	"./udinese-logo-icon.png": "af0a",
	"./ukraine-logo-icon.png": "06ac",
	"./ulster-rugby-logo-icon.png": "7f3c",
	"./union-berlin-logo-icon.png": "e282",
	"./union-saint-gilloise-logo-icon.png": "1eaa",
	"./united-states-logo-icon.png": "4c4f",
	"./uruguay-logo-icon.png": "1392",
	"./valencia-logo-icon.png": "80c8",
	"./vietnam-logo-icon.png": "e34f",
	"./viktoria-plzen-logo-icon.png": "687b",
	"./villarreal-logo-icon.png": "82bb",
	"./wales-logo-icon.png": "9e76",
	"./west-ham-united-logo-icon.png": "5890",
	"./west-indies-logo-icon.png": "96e6",
	"./wolverhampton-wanderers-logo-icon.png": "ee99",
	"./young-boys-logo-icon.png": "1f30",
	"./zalgiris-logo-icon.png": "d1db",
	"./zambia-logo-icon.png": "068f",
	"./zebre-parma-logo-icon.png": "83d5",
	"./zimbabwe-logo-icon.png": "df94"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5bf9";